import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import { pub } from "@/lib/api";

export function MaintenanceGate({ children }) {
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    let timer;
    const check = () => pub.get("/system/status").then((r) => {
      if (r.data.maintenance) { setMsg(r.data.message); timer = setTimeout(check, 15000); }
      else setMsg((m) => { if (m) window.location.reload(); return null; });
    }).catch(() => { timer = setTimeout(check, 15000); });
    const onEvt = (e) => { setMsg(e.detail || "ACE eSIGN is being upgraded."); clearTimeout(timer); timer = setTimeout(check, 15000); };
    window.addEventListener("ace:maintenance", onEvt);
    check();
    return () => { window.removeEventListener("ace:maintenance", onEvt); clearTimeout(timer); };
  }, []);
  if (!msg) return children;
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid="maintenance-screen">
      <div className="max-w-md text-center space-y-4">
        <img src="/ace-logo.png" alt="ACE eSIGN" className="w-44 mx-auto" />
        <Wrench className="w-10 h-10 mx-auto text-brand" />
        <h1 className="text-2xl font-semibold text-slate-900">Under maintenance</h1>
        <p className="text-slate-600" data-testid="maintenance-message">{msg}</p>
        <p className="text-xs text-slate-500">This page reloads automatically as soon as the upgrade is finished.</p>
      </div>
    </div>
  );
}
